/** 操作日志：目标类型（英文编码 → 中文） */
const TARGET_TYPE_LABELS = {
  ACTIVITY_LOTTERY: '活动抽奖',
  ACTIVITY_SATISFACTION: '活动满意度问卷',
  ALBUM_TAB: '相册',
  ARTICLE: '资讯文章',
  ARTICLE_MANAGE: '资讯管理',
  BADGE_TEMPLATE: '胸卡模板',
  CMS: '首页内容',
  CMS_ACTIVITY: '活动',
  CMS_TILE_PAGE_TYPE: '首页入口类型',
  COOPERATION: '跨组织合作',
  DICT: '字典',
  FORM: '表单',
  HOME_SECTION: '首页区块',
  MEMBER: '会员',
  MEMBER_AUTH_IDENTITY: '会员登录身份',
  MEMBER_MAP_PROFILE: '用户档案',
  MEMBER_ORDER: '会员订单',
  MEMBER_TAG: '会员标签',
  MEMBERSHIP: '入会/会费',
  MEMBERSHIP_CONFIRM: '确认函',
  MEMBERSHIP_FEE: '缴费函',
  MEMBERSHIP_FEE_PRICING: '会费定价',
  MESSAGE: '消息',
  NETWORK_CONNECTION: '人脉订单',
  NETWORK_RESOURCE_CONFIG: '人脉资源配置',
  NOTIFICATIONS: '通知',
  PAGE_CONTENT: '页面内容',
  RBAC: '权限账号',
  SERVICE_FORM: '服务登记',
  STAFF: '职员',
  STATS: '统计',
  SUPPLY: '供需',
  UPLOAD: '文件上传',
}

/** 常见动作整句翻译（优先于拆分解析） */
const ACTION_LABELS = {
  MEMBER_AUTH_UNBIND: '解绑会员登录身份',
  MEMBER_AUTH_BIND: '绑定会员登录身份',
  SUPPLY_POST_REVIEW: '审核供需帖',
  NETWORK_CONNECTION_REQUEST_REVIEW: '审核人脉订单',
  FORM_SUBMISSION_REVIEW: '审核表单提交',
}

/** 动作末尾动词 */
const ACTION_VERB_LABELS = {
  CREATE: '新增',
  ADD: '新增',
  UPDATE: '修改',
  EDIT: '编辑',
  SAVE: '保存',
  DELETE: '删除',
  REMOVE: '删除',
  REVIEW: '审核',
  APPROVE: '通过',
  REJECT: '驳回',
  PASS: '通过',
  UNBIND: '解绑',
  BIND: '绑定',
  SEND: '发送',
  PUBLISH: '发布',
  DISABLE: '停用',
  ENABLE: '启用',
  ASSIGN: '分配',
  IMPORT: '导入',
  EXPORT: '导出',
  SYNC: '同步',
  RESET: '重置',
  SUBMIT: '提交',
  CANCEL: '取消',
  UPLOAD: '上传',
}

/** 动作/类型中的英文片段 */
const WORD_LABELS = {
  MEMBER: '会员',
  AUTH: '登录',
  IDENTITY: '身份',
  CMS: '内容',
  ACTIVITY: '活动',
  ARTICLE: '资讯',
  SUPPLY: '供需',
  POST: '帖子',
  FORM: '表单',
  SUBMISSION: '提交记录',
  NETWORK: '人脉',
  CONNECTION: '订单',
  REQUEST: '申请',
  MESSAGE: '消息',
  DICT: '字典',
  RBAC: '权限',
  ROLE: '角色',
  USER: '用户',
  TEMPLATE: '模板',
  BADGE: '胸卡',
  COOPERATION: '合作',
  ALBUM: '相册',
  BANNER: '轮播',
  TILE: '入口',
  PAGE: '页面',
  CONTENT: '内容',
  SERVICE: '服务',
  FEE: '会费',
  MEMBERSHIP: '入会',
  CONFIRM: '确认函',
  PRICING: '定价',
  TAG: '标签',
  ORDER: '订单',
  PROFILE: '档案',
  MAP: '地图',
  SATISFACTION: '满意度',
  LOTTERY: '抽奖',
  REGISTRATION: '报名',
  SEATING: '排座',
  PASSIVE: '被动消息',
  RECIPIENT: '接收人',
}

/** 关联编号列：按目标类型显示前缀 */
const TARGET_ID_PREFIX = {
  MEMBER: '会员编号',
  MEMBER_AUTH_IDENTITY: '身份记录编号',
  CMS_ACTIVITY: '活动编号',
  ACTIVITY: '活动编号',
  ARTICLE: '文章编号',
  FORM: '表单编号',
  SUPPLY: '供需编号',
  NETWORK_CONNECTION: '订单编号',
  MESSAGE: '消息编号',
  DICT: '字典项编号',
  RBAC: '账号编号',
}

function humanizeSnake(code) {
  const raw = String(code || '').trim()
  if (!raw) return '—'
  return raw
    .split('_')
    .filter(Boolean)
    .map((part) => WORD_LABELS[part] || part.toLowerCase())
    .join('')
}

export function labelTargetType(code) {
  const c = String(code || '').trim()
  if (!c) return '—'
  return TARGET_TYPE_LABELS[c] || humanizeSnake(c)
}

export function labelAction(code) {
  const c = String(code || '').trim()
  if (!c) return '—'
  if (ACTION_LABELS[c]) return ACTION_LABELS[c]

  const parts = c.split('_').filter(Boolean)
  if (!parts.length) return c

  const verb = parts[parts.length - 1]
  const verbLabel = ACTION_VERB_LABELS[verb]
  if (verbLabel && parts.length > 1) {
    const subject = parts.slice(0, -1).join('_')
    const subjectLabel = TARGET_TYPE_LABELS[subject] || humanizeSnake(subject)
    return `${subjectLabel}${verbLabel}`
  }

  return humanizeSnake(c)
}

export function formatTargetId(targetType, targetId) {
  const id = targetId == null ? null : Number(targetId)
  if (!Number.isFinite(id) || id <= 0) return '—'
  const type = String(targetType || '').trim()
  const prefix = TARGET_ID_PREFIX[type] || '记录编号'
  return `${prefix} ${id}`
}

export function formatDetailPreview(detailJson) {
  const raw = String(detailJson || '').trim()
  if (!raw) return '—'
  try {
    const obj = JSON.parse(raw)
    const path = obj.path ? String(obj.path) : ''
    const method = obj.httpMethod ? String(obj.httpMethod) : ''
    const parts = []
    if (method) parts.push(method)
    if (path) parts.push(path)
    if (parts.length) return parts.join(' ')
  } catch {
    // keep raw
  }
  return raw.length > 120 ? `${raw.slice(0, 120)}…` : raw
}

export function parseLogDetail(detailJson) {
  const raw = String(detailJson || '').trim()
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

/** 兼容 detailJson / detail_json */
export function rowDetailJson(row) {
  if (!row || typeof row !== 'object') return ''
  return String(row.detailJson ?? row.detail_json ?? '').trim()
}

export function logClientIp(detailJson) {
  const d = parseLogDetail(detailJson)
  const ip = d && d.clientIp ? String(d.clientIp).trim() : ''
  return ip || '—'
}

export function logRequestPath(detailJson) {
  const d = parseLogDetail(detailJson)
  if (!d || !d.path) return '—'
  const path = String(d.path)
  const query = d.query ? String(d.query) : ''
  return query ? `${path}?${query}` : path
}

export function logHttpMethod(detailJson) {
  const d = parseLogDetail(detailJson)
  return d && d.httpMethod ? String(d.httpMethod) : '—'
}

export function logHandlerMethod(detailJson) {
  const d = parseLogDetail(detailJson)
  const h = d && d.handler
  if (!h) return '—'
  return String(h).replace('#', '.')
}

export function logParamsPretty(detailJson, row) {
  const d = parseLogDetail(detailJson)
  const payload = {}
  if (d && d.params && typeof d.params === 'object') {
    Object.assign(payload, d.params)
  }
  if (row) {
    const rel = formatTargetId(row.targetType, row.targetId)
    if (rel !== '—') payload.关联编号 = rel
  }
  if (!Object.keys(payload).length) {
    if (d && !d.params) return '—'
    return '—'
  }
  try {
    return JSON.stringify(payload, null, 2)
  } catch {
    return String(payload)
  }
}

/** 详情弹窗：操作模块（系统模块/动作） */
export function logModulePathLabel(row) {
  const module = labelTargetType(row?.targetType)
  const action = labelAction(row?.action)
  if (module === '—' && action === '—') return '—'
  if (module === '—') return action
  if (action === '—') return module
  return `${module}/${action}`
}

export function logLoginInfo(row) {
  const name = String(row?.adminUserName || row?.admin_user_name || '').trim() || '—'
  const ip = logClientIp(rowDetailJson(row))
  if (ip === '—') return name
  return `${name} / ${ip}`
}
